import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_881d6a94 from 'nuxt_plugin_plugin_881d6a94' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_4c7ae4f8 from 'nuxt_plugin_plugin_4c7ae4f8' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_image_71475872 from 'nuxt_plugin_image_71475872' // Source: ./image.js (mode: 'all')
import nuxt_plugin_vuescrollto_c01e9c86 from 'nuxt_plugin_vuescrollto_c01e9c86' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_gtm_29d53ebc from 'nuxt_plugin_gtm_29d53ebc' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_47555268 from 'nuxt_plugin_axios_47555268' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_85fdd768 from 'nuxt_plugin_moment_85fdd768' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_context_d33ab58a from 'nuxt_plugin_context_d33ab58a' // Source: ../plugins/context (mode: 'server')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_cms_caead256 from 'nuxt_plugin_cms_caead256' // Source: ../plugins/cms (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_flows_226a0791 from 'nuxt_plugin_flows_226a0791' // Source: ../plugins/flows (mode: 'all')
import nuxt_plugin_url_caea4a0a from 'nuxt_plugin_url_caea4a0a' // Source: ../plugins/url (mode: 'all')
import nuxt_plugin_hiddenFields_e8c9ee12 from 'nuxt_plugin_hiddenFields_e8c9ee12' // Source: ../plugins/hiddenFields (mode: 'all')
import nuxt_plugin_helpers_e49953de from 'nuxt_plugin_helpers_e49953de' // Source: ../plugins/helpers (mode: 'all')
import nuxt_plugin_seo_caea5c2e from 'nuxt_plugin_seo_caea5c2e' // Source: ../plugins/seo (mode: 'all')
import nuxt_plugin_services_ac10db5c from 'nuxt_plugin_services_ac10db5c' // Source: ../plugins/services (mode: 'all')
import nuxt_plugin_toast_233078b3 from 'nuxt_plugin_toast_233078b3' // Source: ../plugins/toast (mode: 'all')
import nuxt_plugin_intlTelInput_40e7f440 from 'nuxt_plugin_intlTelInput_40e7f440' // Source: ../plugins/intlTelInput (mode: 'all')
import nuxt_plugin_tracking_08e9f26e from 'nuxt_plugin_tracking_08e9f26e' // Source: ../plugins/tracking.client (mode: 'client')
import nuxt_plugin_browserrum_f467601e from 'nuxt_plugin_browserrum_f467601e' // Source: ../plugins/browser-rum (mode: 'all')
import nuxt_plugin_momentcustom_60adca6a from 'nuxt_plugin_momentcustom_60adca6a' // Source: ../plugins/moment-custom (mode: 'all')
import nuxt_plugin_auth_3c6248e4 from 'nuxt_plugin_auth_3c6248e4' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_auth_37218adb from 'nuxt_plugin_auth_37218adb' // Source: ../plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"X-UA-Compatible","content":"IE=Edge,chrome=1"}],"link":[{"rel":"preload","as":"script","href":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fapi.js"},{"rel":"preconnect","href":"https:\u002F\u002Fapp.crossengage.io"},{"rel":"preconnect","href":"https:\u002F\u002Ftrk-api.crossengage.io"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google.com"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google-analytics.com"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TGFNTGN')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TGFNTGN&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_881d6a94 === 'function') {
    await nuxt_plugin_plugin_881d6a94(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_4c7ae4f8 === 'function') {
    await nuxt_plugin_plugin_4c7ae4f8(app.context, inject)
  }

  if (typeof nuxt_plugin_image_71475872 === 'function') {
    await nuxt_plugin_image_71475872(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_c01e9c86 === 'function') {
    await nuxt_plugin_vuescrollto_c01e9c86(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_29d53ebc === 'function') {
    await nuxt_plugin_gtm_29d53ebc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_47555268 === 'function') {
    await nuxt_plugin_axios_47555268(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_85fdd768 === 'function') {
    await nuxt_plugin_moment_85fdd768(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_context_d33ab58a === 'function') {
    await nuxt_plugin_context_d33ab58a(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_cms_caead256 === 'function') {
    await nuxt_plugin_cms_caead256(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_flows_226a0791 === 'function') {
    await nuxt_plugin_flows_226a0791(app.context, inject)
  }

  if (typeof nuxt_plugin_url_caea4a0a === 'function') {
    await nuxt_plugin_url_caea4a0a(app.context, inject)
  }

  if (typeof nuxt_plugin_hiddenFields_e8c9ee12 === 'function') {
    await nuxt_plugin_hiddenFields_e8c9ee12(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_e49953de === 'function') {
    await nuxt_plugin_helpers_e49953de(app.context, inject)
  }

  if (typeof nuxt_plugin_seo_caea5c2e === 'function') {
    await nuxt_plugin_seo_caea5c2e(app.context, inject)
  }

  if (typeof nuxt_plugin_services_ac10db5c === 'function') {
    await nuxt_plugin_services_ac10db5c(app.context, inject)
  }

  if (typeof nuxt_plugin_toast_233078b3 === 'function') {
    await nuxt_plugin_toast_233078b3(app.context, inject)
  }

  if (typeof nuxt_plugin_intlTelInput_40e7f440 === 'function') {
    await nuxt_plugin_intlTelInput_40e7f440(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracking_08e9f26e === 'function') {
    await nuxt_plugin_tracking_08e9f26e(app.context, inject)
  }

  if (typeof nuxt_plugin_browserrum_f467601e === 'function') {
    await nuxt_plugin_browserrum_f467601e(app.context, inject)
  }

  if (typeof nuxt_plugin_momentcustom_60adca6a === 'function') {
    await nuxt_plugin_momentcustom_60adca6a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_3c6248e4 === 'function') {
    await nuxt_plugin_auth_3c6248e4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_37218adb === 'function') {
    await nuxt_plugin_auth_37218adb(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
